import { combineReducers } from 'redux';
import referrals from './Referrals/reducer';
import statistics from './Statistics/reducer';

export default combineReducers({
  referrals,
  statistics
});
